import React, { useEffect, useState, useRef } from 'react';
import SvgPv from './SvgPv';
import SvgInverters from './SvgInverters';
import SvgLoad from './SvgLoad';
import SvgEPS from './SvgEPS';
import SvgHLine from './SvgHLine';
import SvgVLine from './SvgVLine';
import { TextRotateUpOutlined } from '@material-ui/icons';


function SvgGroupPvAndInvertersAndLoad({ SN, x, y, width, height, Combinations, onGotoIvnerterList }) {
    // let slaveAs = [];
    // let slaveBs = [];
    // let slaveCs = [];
    // let slaveGs = [];
    let flowingFromInverter = false; 
    let flowingToInverter = false;
    let flowingFromPv = false;
    let flowingToGrid = false;
    let flowingFromGrid = false;
    let flowingToLoad = false;
    let flowingToEPS = false;
    let invRowsCount = 0;
    let invColumnsCount = 0;
    // The following variables hold statistical values
    let svg_invs_y = 0;
    let svg_invs_y2 = 0;
    let svg_invs_x2 = 0;


    if (Combinations != null) {
        // let c = Combinations[0];
        // c.PAC1Load = 10;
        let v1 = 0;
        let v2 = 0;
        let v3 = 0;
        let CTPresent = 0;
        let AntiBackflow = 0;
        //当Customer==3 and CTPersent==1时，CTAC[1-3]Power 为整时表示从电网取电；其它情况时CTAC[1-3]Power为正时表示向电网发电
        let Customer = 0; // 2026.2.9 0：通用版 1：清陶 2：同方 3：津荣。
        Combinations.forEach((item, index) => {
            if (item.CTPresent === 1) {
                CTPresent = 1;
            }
            if (item.AntiBackflow === 1) {
                AntiBackflow = 1;
            }
            if (item.Customer != null && item.Customer > 0) {
                Customer = parseInt(item.Customer);
            }
            if ((item.PPV1 != null && Math.round(item.PPV1/10) > 0) || (item.PPV2 != null && Math.round(item.PPV2/10) > 0) || (item.PPV3 != null && Math.round(item.PPV3/10) > 0) || (item.PPV4 != null && Math.round(item.PPV4/10) > 0)) {
                flowingFromPv = true;
            }
            if ((item.PAC1Load != null && Math.round(item.PAC1Load/10) > 0) || (item.PAC2Load != null && Math.round(item.PAC2Load/10) > 0) || (item.PAC3Load != null && Math.round(item.PAC3Load/10) > 0)) {
                flowingToLoad = true;
            }
            if ((item.PAC1EPS != null &&  Math.round(item.PAC1EPS/10) > 0) || (item.PAC2EPS != null && Math.round(item.PAC2EPS/10) > 0) || (item.PAC3EPS != null && Math.round(item.PAC3EPS/10) > 0)) {
                flowingToEPS = true;
            }
            if( (item.PAC1Grid != null && item.PAC1Grid > 0) || (item.PAC2Grid != null && item.PAC2Grid > 0) || (item.PAC3Grid != null && item.PAC3Grid > 0)) {
                if (item.PAC1Grid != null && item.PAC1Grid > 0) {
                    let vv1 = parseInt(item.PAC1Grid);
                    if (vv1 > 0x7fffffff) {
                        vv1 = vv1 - 0x100000000;
                    }
                    v1 += vv1;
                } 
                if (item.PAC2Grid != null && item.PAC2Grid > 0) {
                    let vv2 = parseInt(item.PAC2Grid);
                    if (vv2 > 0x7fffffff) {
                        vv2 = vv2 - 0x100000000;
                    }
                    v2 += vv2;
                } 
                if (item.PAC3Grid != null && item.PAC3Grid > 0) {
                    let vv3 = parseInt(item.PAC3Grid);
                    if (vv3 > 0x7fffffff) {
                        vv3 = vv3 - 0x100000000;
                    }
                    v3 += vv3;
                }                
            }            
        });
        let pTotal = Math.round((v1+v2+v3)/10);
        if (Math.abs(pTotal) < 100) {
            v1 = 0;
            v2 = 0;
            v3 = 0;
         }
        if (Math.round((v1+v2+v3)/10) < 0) {
            // if (Customer == 3) {
            //     flowingFromInverter = true;
            // } else {
            //     flowingToInverter = true;
            // }
            flowingToInverter = true;
        } else if (Math.round((v1+v2+v3)/10) > 0) {
            // if (Customer == 3) {
            //     flowingToInverter = true;
            // } else {
            //     flowingFromInverter = true;
            // }
            flowingFromInverter = true;
        }
        if (CTPresent === 1) {
            v1 = 0;
            v2 = 0;
            v3 = 0;
            Combinations.forEach((item, index) => {
                if( (item.PAC1CT != null && item.PAC1CT > 0) || (item.PAC2CT != null && item.PAC2CT > 0) || (item.PAC3CT != null && item.PAC3CT > 0)) {
                    if (item.PAC1CT != null && item.PAC1CT > 0) {
                        let vv1 = parseInt(item.PAC1CT);
                        if (vv1 > 0x7fffffff) {
                            vv1 = vv1 - 0x100000000;
                        }
                        v1 += vv1;
                    } 
                    if (item.PAC2CT != null && item.PAC2CT > 0) {
                        let vv2 = parseInt(item.PAC2CT);
                        if (vv2 > 0x7fffffff) {
                            vv2 = vv2 - 0x100000000;
                        }
                        v2 += vv2;
                    } 
                    if (item.PAC3CT != null && item.PAC3CT > 0) {
                        let vv3 = parseInt(item.PAC3CT);
                        if (vv3 > 0x7fffffff) {
                            vv3 = vv3 - 0x100000000;
                        }
                        v3 += vv3;
                    }
                }
            });
            pTotal = Math.round((v1+v2+v3)/10);
            if (Math.abs(pTotal) < 100) {
                v1 = 0;
                v2 = 0;
                v3 = 0;
                pTotal = 0;
            }
            if (pTotal < 0) {
                if (Customer == 3) {
                    if (AntiBackflow === 1) {
                        flowingToGrid = false;
                    } else {
                        flowingToGrid = true;
                    }
                } else {
                    flowingFromGrid = true;
                }
            } else if (pTotal > 0) {
                if (Customer == 3) {
                    flowingFromGrid = true;
                } else {
                    if (AntiBackflow === 1) {
                        flowingToGrid = false;
                    } else {
                        flowingToGrid = true;
                    }
                }
            }
        } else {
            flowingToGrid = flowingFromInverter
            flowingFromGrid = flowingToInverter
        }
    }
    if (Combinations != null && Combinations.length > 0) {
        invRowsCount = Math.ceil(Combinations.length / 3);
        invColumnsCount = invRowsCount > 1 ? 3 : Combinations.length;
    }

    if (invColumnsCount+invRowsCount > 2) {
        svg_invs_x2 = (110 + 15) * invColumnsCount - 15 + 10*2;
        svg_invs_y = (height - (70 + 20) * invRowsCount + 20) / 2;
        svg_invs_y2 = (height + (70 + 20) * invRowsCount - 20)/2 + 10*2;
    } else {
        svg_invs_x2 = 110;
        svg_invs_y = (height - 70) / 2;
        svg_invs_y2 = (height + 70) / 2;
    }
    if (invRowsCount >= 3) {
        let y = (height - (70 + 20) * 3 + 20) / 2;
        let y2 = (height + (70 + 20) * 3 - 20) / 2;
        svg_invs_x2 = svg_invs_x2 / (svg_invs_y2 - svg_invs_y) * (y2 - y);
        svg_invs_y = y;
        svg_invs_y2 = y2;
    }

    console.log("svg_invs_y", svg_invs_y);
    console.log("svg_invs_y2", svg_invs_y2);
    return (<svg x={x} y={y} width={width} height={height}>
        <SvgPv x={18} y={15} Combinations={Combinations}/>

        <SvgInverters x={0} y={svg_invs_y} width={svg_invs_x2} height={svg_invs_y2 - svg_invs_y} invColumnsCount={invColumnsCount} invRowsCount={invRowsCount} Combinations={Combinations|| []} onGotoIvnerterList={onGotoIvnerterList}/>
        <SvgEPS x={11} y={height - 84 - 15} Combinations={Combinations}/>
        <SvgLoad x={260} y={height - 84 - 15} Combinations={Combinations}/>
        {flowingFromPv && <SvgVLine id={SN+"flowingFromPv"} x={13 + (84 - 6) / 2} y={15 + 84} y2={svg_invs_y} />}
        {flowingToEPS && <SvgVLine id={SN+"flowingToEPS"} x={11 + (84 - 6) / 2} y={svg_invs_y2} y2={height - 84 - 15} />}
        {flowingToLoad && (flowingFromInverter || flowingFromGrid) && <SvgVLine id={SN+"flowingToLoad"} x={251 + (84 - 6) / 2} y={(svg_invs_y+svg_invs_y2)/2} y2={height - 84 - 15} />}
        {/* ->- */}
        {flowingToGrid && flowingFromInverter && <SvgHLine id={SN+"flowingToGrid"} x={svg_invs_x2} y={height / 2} x2={width - 3} />} 
        {/* -<- */}
        {flowingFromGrid && flowingToInverter && <SvgHLine id={SN+"flowingFromGrid"} x={width - 3} y={height / 2} x2={svg_invs_x2} />}
        {/* -| */}
        {flowingFromInverter && flowingToLoad && (!flowingToGrid) && <SvgHLine id={SN+"flowingToGrid"} x={svg_invs_x2} y={height / 2} x2={251 + (84 - 6) / 2} />}
        {/* |- */}
        {flowingFromGrid && flowingToLoad && (!flowingToInverter) && <SvgHLine id={SN+"flowingFromGrid"} x={width - 3} y={height / 2} x2={251 + (84 - 6) / 2} />}
        
    </svg>)
}

export default SvgGroupPvAndInvertersAndLoad;